import Vue from "vue";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
import App from "@/App.vue";
import router from "@/router";

import AuthService from "@/auth/authService";

import fragmentMatcher from "@/fragmentMatcher";
import VueApollo from "vue-apollo";
import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink
} from "apollo-boost";

function getAPIURL() {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:8080/query"
  } else if (process.env.VUE_APP_DEMO) {
    return "https://demoapi.mindsight.io/query"
  }
  return "https://api.mindsight.io/query"
}

function getAPIToken() {
  if (process.env.VUE_APP_DEMO) {
    return null
  }
  var token = localStorage.getItem("access_token")
  if (token) {
    return "bearer " + token
  }
  return null
}

const httpLink = new HttpLink({
  uri: getAPIURL()
});

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization: getAPIToken()
    }
  });
  return forward(operation);
});

const mindsightLink = authLink.concat(httpLink);

const cache = new InMemoryCache({ fragmentMatcher });

export const apolloClient = new ApolloClient({
  link: mindsightLink,
  cache: cache,
  connectToDevTools: true
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

Vue.config.productionTip = false;

Vue.use(Buefy);
Vue.use(VueTour);
Vue.use(VueApollo);

Vue.prototype.$auth0 = new AuthService();

new Vue({
  router,
  provide: apolloProvider.provide(),
  render: h => h(App)
}).$mount("#app");

var numeral = require("numeral");

Vue.filter("percentage", value => {
  return numeral(value).format("0.0") + "%";
});
